import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class ExclamationIcon extends Component {
    static defaultProps = {
        ...AbstractIconDefaultProps,
        style: { color: '#000000' }
    };
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 25 24" {...props}>
                <path
                    d="M12.5 12.7637V8.26367M12.5 21.2637C7.52943 21.2637 3.5 17.2342 3.5 12.2637C3.5 7.2931 7.52943 3.26367 12.5 3.26367C17.4706 3.26367 21.5 7.2931 21.5 12.2637C21.5 17.2342 17.4706 21.2637 12.5 21.2637Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
                <path
                    d="M12.5075 15.5967C12.4155 15.5967 12.3405 15.6717 12.3415 15.7637C12.3415 15.8557 12.4165 15.9307 12.5085 15.9307C12.6005 15.9307 12.6755 15.8557 12.6755 15.7637C12.6755 15.6717 12.6005 15.5967 12.5075 15.5967"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            </AbstractIcon>
        );
    }
}
